import { ResourcesProvider, SitesProvider } from 'src/cqrs/client/providers';

import { oneService } from './oneService';

/**
 * Shared, per-tab provider instances bound to the single OneService. Import
 * these anywhere in the app (hooks, thunks) instead of constructing providers
 * ad-hoc, so every domain call rides the same transport, connection and cache.
 */
export const resourcesProvider = new ResourcesProvider(oneService);
export const sitesProvider = new SitesProvider(oneService);
